import { render, staticRenderFns } from "./yessdiscounts.vue?vue&type=template&id=62fe66a4&scoped=true"
import script from "./yessdiscounts.vue?vue&type=script&lang=js"
export * from "./yessdiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe66a4",
  null
  
)

export default component.exports